import { useEffect, useState } from 'react'
import usePagination from './usePagination'
import {
  FilterOrder,
  LearningActivityOrderByInput,
  Maybe,
  Scalars,
} from 'lib/graphql/graphqlTypes'
import { ApolloQueryResult } from '@apollo/client'

export interface CommonOrder {
  value?: Maybe<string>
  order?: Maybe<FilterOrder>
}

interface TableInputs {
  input?: Maybe<{
    order?: CommonOrder
    pageSize?: Maybe<Scalars['Int']>
    page?: Maybe<Scalars['Int']>
    filters?: Maybe<any>
    orderBy?: Maybe<CommonOrder>
  }>
}

interface Props {
  orderBy?: string
  pageSize?: number
}

const useTable = <T extends TableInputs>({ orderBy, pageSize = 5 }: Props) => {
  let refetch: (variables?: Partial<any>) => Promise<ApolloQueryResult<any>>

  const setRefetch = (
    refetchFunc: (variables?: any) => Promise<ApolloQueryResult<any>>,
  ) => {
    refetch = refetchFunc
  }

  const { Pagination, paginationProps } = usePagination()
  const [ordering, setOrdering] = useState<CommonOrder>({
    value: orderBy || '',
    order: FilterOrder.ASC,
  })

  useEffect(() => {
    if (refetch) refetch()
  }, [paginationProps.currentPage, ordering])

  const inputVal = {
    page: paginationProps.currentPage,
    pageSize,
    orderBy: ordering,
  } as T['input']

  const sortHandler = (orderBy: string, order: string) => {
    setOrdering({
      order: order.toUpperCase(),
      value: orderBy.toUpperCase(),
    } as LearningActivityOrderByInput)
  }

  return {
    Pagination,
    paginationProps,
    ordering,
    sortHandler,
    inputVal,
    setRefetch,
  }
}

export default useTable
